var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import { space, minWidth, width, position, flex, flexDirection, backgroundColor, } from 'styled-system';
import { boxSizing } from '../../../common/theme/system-utilities';
var SearchFormContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  transition-property: top, transform, opacity, background-color;\n  transition-timing-function: ease-in-out;\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  transition-property: top, transform, opacity, background-color;\n  transition-timing-function: ease-in-out;\n\n  ",
    ";\n\n  ",
    ";\n\n  ",
    ";\n"])), position, flex, flexDirection, width, minWidth, space, boxSizing, backgroundColor, function (_a) {
    var transitionState = _a.transitionState;
    return transitionState !== 'exited' && {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 9999999,
    };
}, function (_a) {
    var transitionState = _a.transitionState, timeout = _a.timeout;
    return ['entering', 'entered'].includes(transitionState) && {
        backgroundColor: 'white',
        transitionDuration: timeout + "ms",
    };
}, function (_a) {
    var transitionState = _a.transitionState, timeout = _a.timeout;
    return transitionState !== 'entering' && {
        transitionDuration: timeout + "ms",
        transitionDelay: timeout + "ms",
    };
});
SearchFormContainer.defaultProps = {
    position: ['static', 'relative'],
    flexDirection: 'column',
    width: 1,
    my: 0,
    mx: 'auto',
    boxSizing: 'border-box',
    backgroundColor: 'transparent',
};
export default SearchFormContainer;
var templateObject_1;
